(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lg-behavior"] && !Shopify.designMode) return;
  try {
    const luckySizeSelection = new Map();
if (!customElements.get('lg-collection')) {
 customElements.define('lg-collection', class extends HTMLElement {
  connectedCallback() {
   this.next = this.dataset.next; this.size = luckySizeSelection.get(this.dataset.section) || ''; this.busy = false; this.controller = new AbortController();
   this.grid = this.querySelector('#product-grid'); this.more = this.querySelector('.lg-load-more'); this.status = this.querySelector('.lg-load-status');
   this.addEventListener('click', event => {
    const button = event.target.closest('[data-size]');
    if (button) {
     this.size = button.dataset.size; luckySizeSelection.set(this.dataset.section,this.size);
     this.querySelectorAll('[data-size]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
     this.applyFilter();
     if (this.size && this.next) this.load();
    }
    if(event.target.closest('.lg-load-more')) {event.preventDefault(); this.load();}
   }, {signal:this.controller.signal});
   this.observer = new IntersectionObserver(entries => {if(entries.some(e => e.isIntersecting)) this.load();}, {rootMargin:'500px'});
   if(this.more && !this.dataset.manual) this.observer.observe(this.more);
   this.querySelectorAll('[data-size]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.size===this.size)));
   this.applyFilter();
   if(this.size && this.next) this.load();
  }
  disconnectedCallback() {this.controller.abort(); this.observer?.disconnect();}
  applyFilter() {
   if(!this.grid) return;
   let count=0;
   Array.from(this.grid.children).forEach(card => {
    const size = card.querySelector('[data-lg-size]')?.dataset.lgSize || '';
    card.hidden = Boolean(this.size && size !== this.size);
    if(!card.hidden) count++;
   });
   if(this.status) this.status.textContent = this.size ? (this.next ? this.dataset.scanning : count ? `${count} ${this.dataset.found}` : this.dataset.empty) : (!this.next ? this.dataset.end : '');
  }
  async load() {
   if(this.busy || !this.next || !this.isConnected) return;
   this.busy=true;
   if(this.more) this.more.setAttribute('aria-disabled','true');
   if(this.status) this.status.textContent=this.size ? this.dataset.scanning : this.dataset.loading;
   let succeeded=false;
   try {
    const url=new URL(this.next,location.origin); url.searchParams.set('section_id',this.dataset.section);
    const response=await fetch(url,{signal:this.controller.signal}); if(!response.ok) throw new Error('Load failed');
    const html=await response.text(); if(!this.isConnected) return;
    const doc=new DOMParser().parseFromString(html,'text/html');
    const incoming=doc.querySelector('lg-collection'); const grid=incoming?.querySelector('#product-grid');
    if(!grid) throw new Error('Missing grid');
    Array.from(grid.children).forEach(card=>{card.classList.remove('scroll-trigger','animate--slide-in');this.grid.append(card);});
    this.next=incoming.dataset.next;
    if(this.more) {this.more.hidden=!this.next; if(this.next) this.more.href=this.next;}
    this.applyFilter(); succeeded=true;
    document.dispatchEvent(new CustomEvent('lucky:products:loaded'));
   } catch(error) {
    if(error.name!=='AbortError' && this.status) {this.status.textContent=this.dataset.error; this.observer.disconnect();}
   } finally {
    this.busy=false; this.more?.removeAttribute('aria-disabled');
    if(succeeded && this.next && this.isConnected) {
     if(!this.dataset.manual && (this.size || (this.more && this.more.getBoundingClientRect().top < innerHeight+500))) this.load();
    }
   }
  }
 });
}
if(!customElements.get('lg-announcements')) {
 customElements.define('lg-announcements',class extends HTMLElement {
  connectedCallback(){
   this.slides=Array.from(this.querySelectorAll('div>span'));this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.show();
   this.onclick=e=>{const step=e.target.closest('[data-direction]');if(step){this.index+=Number(step.dataset.direction);this.show();}if(e.target.closest('[data-pause]')){this.paused=!this.paused;this.querySelector('[data-pause]').textContent=this.paused?'▶':'Ⅱ';this.querySelector('[data-pause]').setAttribute('aria-label',this.paused?'Play':'Pause');}};
   this.timer=setInterval(()=>{if(!this.paused && !document.hidden && !this.matches(':hover,:focus-within')){this.index++;this.show();}},4500);
  }
  show(){if(!this.slides.length)return;this.index=(this.index+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>s.hidden=i!==this.index);}
  disconnectedCallback(){clearInterval(this.timer);}
 });
}
function luckyInitOffers(){
 const dialog=document.querySelector('[data-lg-coupons]');const trigger=document.querySelector('[data-lg-open]');const offer=document.querySelector('[data-lg-offer]');
 const storage={get(k){try{return sessionStorage.getItem(k);}catch{return null;}},set(k,v){try{sessionStorage.setItem(k,v);}catch{}}};
 if(offer && !offer.dataset.ready){offer.dataset.ready='true';offer.hidden=true; if(storage.get('lucky-offer-dismissed')!=='1'){const reveal=()=>{if(scrollY>250 && storage.get('lucky-offer-dismissed')!=='1'){offer.hidden=false;removeEventListener('scroll',reveal);}};addEventListener('scroll',reveal,{passive:true});setTimeout(reveal,12000);}offer.querySelector('[data-lg-dismiss]').onclick=()=>{offer.hidden=true;storage.set('lucky-offer-dismissed','1');};}
 if(dialog && !dialog.dataset.ready){
  dialog.dataset.ready='true';
  const open=()=>{if(!dialog.open){dialog.showModal();storage.set('lucky-coupons-seen','1');}};
  if(trigger)trigger.onclick=open;
  dialog.querySelector('[data-lg-close]').onclick=()=>dialog.close();
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  if(!storage.get('lucky-coupons-seen') && !window.Shopify?.designMode)setTimeout(()=>{if(dialog.isConnected && !document.hidden && !document.querySelector('cart-drawer.active') && !document.querySelector('dialog[open]'))open();},18000);
 }
 const form=document.querySelector('product-info product-form');
 if(form && !document.querySelector('.lg-sticky-buy')){
  const original=form.querySelector('[name="add"]');
  if(original){const bar=document.createElement('div');bar.className='lg-sticky-buy';bar.hidden=true;const button=document.createElement('button');button.type='button';button.textContent=original.innerText.trim();bar.append(button);document.body.append(bar);
   button.onclick=()=>{if(!original.disabled) original.click();};
   const sync=()=>{button.textContent=original.innerText.trim();button.disabled=original.disabled;};new MutationObserver(sync).observe(original,{attributes:true,childList:true,subtree:true});
   new IntersectionObserver(entries=>{bar.hidden=entries[0].isIntersecting;},{threshold:0}).observe(form);
  }
 }
}
luckyInitOffers();document.addEventListener('shopify:section:load',luckyInitOffers);
  } catch(e) { console.error(e); }
})();

})();
